import { createContext, useContext } from 'react';
import { defaults } from '../constants';

export interface PaginationContextState {
  pageSize: number;
  setPageSize: (value: number) => void;
  currentPage: number;
  setCurrentPage: (value: number) => void;
}

export const defaultState: PaginationContextState = {
  pageSize: defaults.pageSize,
  setPageSize: () => undefined,
  currentPage: 0,
  setCurrentPage: () => undefined,
};

export const PaginationContext = createContext<PaginationContextState>(defaultState);

export const useInternalPaginationContext = () => useContext(PaginationContext);
